import React from 'react';
import {
  EuiHeader,
  EuiFieldSearch,
  EuiStat,
  EuiFacetButton,
  EuiIcon,
  EuiText,
  EuiSuperSelect,
  EuiHealth,
} from '@elastic/eui';
import { getMessage } from 'utils';

export const LanguageChooser = ({ compressed }) => {
  const [value, setValue] = React.useState(
    localStorage.getItem('language') || 'vi'
  );

  const onChange = (value) => {
    if (!value) return;
    localStorage.setItem('language', value);
    setValue(value);
    window.location.reload();
  };

  const options = [
    {
      value: '',
      inputDisplay: (
        <span>
          {getMessage('pages.auth.login.language_chooser.default_title')}
        </span>
      ),
      'data-test-subj': 'option-warning',
      // disabled: true,
    },
    {
      value: 'vi',
      inputDisplay: (
        <EuiHealth color="success" style={{ lineHeight: 'inherit' }}>
          Tiếng Việt
        </EuiHealth>
      ),
      'data-test-subj': 'option-warning',
      // disabled: true,
    },
    {
      value: 'zh',
      inputDisplay: (
        <EuiHealth color="warning" style={{ lineHeight: 'inherit' }}>
          简体中文
        </EuiHealth>
      ),
      'data-test-subj': 'option-minor',
    },
    {
      value: 'en',
      inputDisplay: (
        <EuiHealth color="accent" style={{ lineHeight: 'inherit' }}>
          English
        </EuiHealth>
      ),
      'data-test-subj': 'option-critical',
    },
  ];

  const renderLangChooser = (
    <EuiSuperSelect
      options={options}
      compressed={compressed}
      lang="en"
      style={{ minWidth: 150, borderRadius: '8px' }}
      valueOfSelected={value}
      onChange={(value) => onChange(value)}
    />
  );

  return renderLangChooser;
};
